import { useEffect, useState } from "react";
import { alCambiarSesion, cargarUsuario, RUTA_CREAR_CONTRASENA, salir } from "../features/auth/authService";
import CompletarDatos from "../features/auth/CompletarDatos";
import CrearContrasena from "../features/auth/CrearContrasena";
import Login from "../features/auth/Login";
import { soloVeSusTurnos } from "../features/auth/secciones";
import { cargarSesion, cerrarSesion, guardarSesion, normalizarUsuario } from "../features/auth/session";
import PastorDashboard from "../layouts/pastor/PastorDashboard";
import ServidorDashboard from "../layouts/servidor/ServidorDashboard";
import AvisosDeError from "../shared/components/AvisosDeError";
import Confirmacion from "../shared/components/Confirmacion";

const vieneDelEnlace = () => window.location.pathname.startsWith(RUTA_CREAR_CONTRASENA);

function App() {
  // Los datos guardados dibujan la app al instante; la sesión de Supabase Auth confirma enseguida.
  const [usuario, setUsuario] = useState(cargarSesion);
  // normal | verificando (llegó del enlace del correo) | crear (crear la contraseña) | vencido (enlace inválido)
  const [paso, setPaso] = useState(() => (vieneDelEnlace() ? "verificando" : "normal"));

  const entrar = (datos) => {
    const nuevo = normalizarUsuario(datos);
    guardarSesion(nuevo);
    setUsuario(nuevo);
    if (vieneDelEnlace()) window.history.replaceState(null, "", "/");
    setPaso("normal");
  };

  const handleLogout = () => {
    setUsuario(null);
    cerrarSesion();
    salir();
  };

  useEffect(() => alCambiarSesion((evento, sesion) => {
    if (evento === "PASSWORD_RECOVERY") setPaso("crear");
    if (evento === "SIGNED_OUT" || (evento === "INITIAL_SESSION" && !sesion)) {
      cerrarSesion();
      setUsuario(null);
    }
    if (evento === "INITIAL_SESSION") {
      setPaso((actual) => (actual === "verificando" ? (sesion ? "crear" : "vencido") : actual));
    }
  }), []);

  // Permisos en vivo: si cambiaron el rol o desactivaron la cuenta, se aplica al abrir la app.
  const idUsuario = usuario?.id;
  useEffect(() => {
    if (!idUsuario) return;
    cargarUsuario()
      .then((vigente) => {
        if (!vigente) return handleLogout();
        setUsuario((actual) => {
          const igual = JSON.stringify(actual?.acceso) === JSON.stringify(vigente.acceso)
            && Boolean(actual?.datos_pendientes) === vigente.datos_pendientes;
          if (!actual || igual) return actual;
          const nuevo = { ...actual, ...vigente };
          guardarSesion(nuevo);
          return nuevo;
        });
      })
      .catch(() => {}); // Sin conexión se conservan los permisos con que entró.
  }, [idUsuario]);

  let contenido;
  if (paso === "verificando") contenido = null;
  else if (paso === "crear") contenido = <CrearContrasena onListo={entrar} />;
  else if (!usuario) contenido = <Login onLogin={entrar} enlaceVencido={paso === "vencido"} />;
  else if (usuario.datos_pendientes) contenido = <CompletarDatos usuario={usuario} onListo={entrar} onSalir={handleLogout} />;
  else {
    // Quien solo ve sus turnos usa la vista sencilla de servidor; los demás, el panel con menú.
    const Layout = soloVeSusTurnos(usuario) ? ServidorDashboard : PastorDashboard;
    contenido = <Layout usuario={usuario} onLogout={handleLogout} />;
  }
  return (
    <>
      {contenido}
      <AvisosDeError />
      <Confirmacion />
    </>
  );
}

export default App;
